import React, { Suspense, ReactNode } from 'react';
import { BrandingProvider } from './BrandingContext';
import { Spin } from '@goalsetter/ant-design-ui';
import { LoadingOutlined } from '@ant-design/icons';
import MetadataInjector from '@/components/MetadataInjector';
import ThemeProvider from '@/assets/ThemeProvider';
import { BrandingDebug } from '@/components/BrandingDebug';

interface BrandingProviderWithSuspenseProps {
  children: ReactNode;
}

const BrandingProviderSuspenseFallback: React.FC = () => {
  const spinnerIcon = { fontSize: 64, color: 'white' };

  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Spin
        indicator={
          <LoadingOutlined
            style={spinnerIcon}
            spin
          />
        }
      />
    </div>
  );
};

export const BrandingProviderWithSuspense: React.FC<
  BrandingProviderWithSuspenseProps
> = ({ children }) => {
  return (
    <Suspense fallback={<BrandingProviderSuspenseFallback />}>
      <BrandingProvider>
        <BrandingDebug />
        <MetadataInjector />
        <ThemeProvider>{children}</ThemeProvider>
      </BrandingProvider>
    </Suspense>
  );
};
